import React, { useState } from "react";
import { useQuery } from "react-query";
import { Card, Select, Typography, Spin, Empty } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getRevenue } from "../../../services/dashboard.service";
import { formatCurrency } from "../../../services/utils";
import moment from "moment";

const { Title } = Typography;
const { Option } = Select;

export default function RevenueExpenseChart() {
  const [months, setMonths] = useState(6); // Default 6 as per layout

  // Merge external params with local months state
  const queryParams = { months };

  const { data, isLoading } = useQuery(
    ["getRevenue", queryParams],
    () => getRevenue(queryParams),
    {
      refetchOnWindowFocus: false,
    }
  );

  const chartData = data?.data || [];

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Title level={5} style={{ margin: 0 }}>
              Receitas
            </Title>
            <Typography.Text type="secondary">
              Últimos {months} meses
            </Typography.Text>
          </div>
          <Select
            defaultValue={6}
            style={{ width: 120 }}
            onChange={(value) => setMonths(value)}
          >
            <Option value={6}>6 meses</Option>
            <Option value={12}>12 meses</Option>
          </Select>
        </div>
      }
      bordered={false}
      style={{ height: "100%" }}
    >
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
          <Spin />
        </div>
      ) : chartData.length > 0 ? (
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <BarChart
              data={chartData}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="month"  tickFormatter={(value: any) => `${moment(value).format('MM/YYYY')}`} />
              <YAxis tickFormatter={(value) => `R$ ${Number(value) / 1000}K`} />
              <Tooltip
                formatter={(value: any) => formatCurrency(Number(value) || 0)}
                labelFormatter={(value: any) => `${moment(value).format('MM/YYYY')}`}
                cursor={{ fill: "transparent" }}
              />
              <Legend />
              <Bar
                dataKey="liquidated"
                name="Receita Realizada"
                fill="#52c41a"
              />
              <Bar dataKey="to_receive" name="A Receber" fill="#b37feb" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <Empty description="Sem dados para o período" />
      )}
    </Card>
  );
}
